var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67759 3.22183C-0.617869 7.51728 -0.617869 14.4827 3.67759 18.7782C7.97305 23.0736 14.9385 23.0736 19.2339 18.7782C23.5294 14.4827 23.5294 7.51728 19.2339 3.22183C14.9385 -1.07363 7.97305 -1.07363 3.67759 3.22183ZM16.456 7.11091L12.5669 11L16.456 14.8891L15.3449 16.0003L11.4558 12.1112L7.56668 16.0003L6.45551 14.8891L10.3446 11L6.45551 7.11091L7.56668 5.99975L11.4558 9.88883L15.3449 5.99974L16.456 7.11091Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Delete.aa45543c.svg";
export { ForwardRef as ReactComponent };